import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';

export interface EventCard {
	title: string;
	description?: string;
	thumbnail?: string;
	status?: string;
	commentsCount?: number;
	date?: string;
	time?: string;
	type?: string;
	actions?: Array<{
		caption: string,
		key: string,
		classes: string | Array<string>
	}>;
	forwarderName?: string;
	forwarderThumbnail?: string;
	eventType: string;
	removable?: boolean;
	rating?: number;
	dateClasses?: Array<string>;
}

@Component({
	selector: 'app-event-card',
	templateUrl: './event-card.component.html',
	styleUrls: ['./event-card.component.scss']
})
export class EventCardComponent implements OnInit, OnChanges {

	@Input() type: 'horizontal' | 'vertical' | 'minimal' = 'horizontal';
	@Input() data: EventCard;

	@Output() detail: any = new EventEmitter();
	@Output() action: any = new EventEmitter();
	@Output() forwarderUser: any = new EventEmitter();
	@Output() remove: any = new EventEmitter();

	cardData;

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) { }

	ngOnInit(): void {
	}

	ngOnChanges(changes) {
		if (changes.data && changes.data.currentValue) {
			this.cardData = changes.data.currentValue;
			if (!([null, undefined].includes(changes.data.currentValue.rating))) {
				if (changes.data.currentValue.rating > 5) {
					changes.data.currentValue.rating = 5;
				}
				const range = this.range(0, Number(parseFloat(changes.data.currentValue.rating.toString())));
				range.splice(0, 1);
				for (let i = range.length; i < 5; i++) {
					range.push(0);
				}
				this.cardData['ratingData'] = range.map(data => {
					return {
						isInt: this.isInt(data),
						isFloat: this.isFloat(data),
						value: data
					};
				});
			}
		}
	}

	private range(start: number, end: number) {
		const foo: number[] = [];
		let endValue: any = end.toString().split('.');
		if (endValue.length) {
			endValue = Number(endValue[0]);
		}
		for (let i = start; i <= end; i++) {
			if (i === endValue) {
				foo.push(end);
			} else {
				foo.push(i);
			}
		}
		return foo;
	}

	isInt(n) {
		return Number(n) === n && n % 1 === 0;
	}

	isFloat(n) {
		return Number(n) === n && n % 1 !== 0;
	}

	info(data) {
		if (navigator.onLine) {
			this.detail.emit(data);
		}
	}

	actionInfo(action) {
		if (navigator.onLine) {
			this.action.emit(action);
		}
	}

	forwarderUserInfo(data) {
		if (navigator.onLine) {
			this.forwarderUser.emit(data);
		}
	}

	close(data) {
		if (navigator.onLine) {
			this.remove.emit(data);
		}
	}

}
